import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { CopyField } from '../../common/CopyField';
import { FC } from 'react';
import { t } from 'i18next';

interface Props {
  open: boolean;
  onClose: () => void;
  apikey: string;
}

export const NewAPIKeyDialog: FC<Props> = ({ open, onClose, apikey }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle style={{ minWidth: 500 }}>{t('dashboard.partner.apikey.dialog.headline')}</DialogTitle>
      <DialogContent>
        <Typography
          style={{
            paddingBottom: 16,
          }}
        >
          {t('dashboard.partner.apikey.dialog.description')}
        </Typography>
        <CopyField fullWidth disabled={true} label="API Key" value={apikey} />
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={onClose}>
          {t('dashboard.partner.apikey.dialog.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
